import { isGalileoSystem } from "@/utils/flight/isGalileoSystem"

/**
 * Galileo (GALLEO_NDC) often returns VJ/JQ itineraries that duplicate dedicated
 * VJ/JQ search. Those cards show the 3 tabs (Chi tiết / Giá vé / Thông tin khác).
 */
export const isVjOrJqSegment = (seg: {
  airline?: string | null
  operatingAirline?: string | null
  flightNumber?: string | null
}) => {
  const normalize = (value?: string | null) =>
    String(value || "").replace(/_/g, "").toUpperCase()

  const airline = normalize(seg.airline)
  const operating = normalize(seg.operatingAirline)
  const flightNumber = normalize(seg.flightNumber)

  return (
    airline === "VJ" ||
    airline === "JQ" ||
    operating === "VJ" ||
    operating === "JQ" ||
    flightNumber.startsWith("VJ") ||
    flightNumber.startsWith("JQ")
  )
}

/** Hide whole Galileo fare if any leg is VJ/JQ (RT combo must stay intact or go). */
export const isGalileoVjOrJqFare = (
  system: string | null | undefined,
  flights?: Array<{
    segments?: Array<{
      airline?: string | null
      operatingAirline?: string | null
      flightNumber?: string | null
    }> | null
  }> | null,
) => {
  if (!isGalileoSystem(system)) {
    return false
  }
  return (flights || []).some((flight) =>
    (flight?.segments || []).some(isVjOrJqSegment),
  )
}
